import { Instance } from 'mobx-state-tree';
import { RouteTimelineLogDtoModelBase } from './RouteTimelineLogDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineLogDtoModel */
export interface RouteTimelineLogDtoModelType extends Instance<typeof RouteTimelineLogDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineLogDtoModel */
export { selectFromRouteTimelineLogDto, routeTimelineLogDtoModelPrimitives, RouteTimelineLogDtoModelSelector } from './RouteTimelineLogDtoModel.base';

/**
 * RouteTimelineLogDtoModel
 */
export const RouteTimelineLogDtoModel = RouteTimelineLogDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
